/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-folder-tree-breadcrumbs{overflow:hidden}ui-folder-tree-breadcrumbs .ui-folder-tree-breadcrumbs-path{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px;margin-bottom:1px}ui-folder-tree-breadcrumbs .ui-folder-tree-breadcrumbs-current-folder{font-weight:700;font-size:20px;display:flex;align-items:center}ui-folder-tree-breadcrumbs .ui-folder-tree-breadcrumbs-current-folder mat-icon{margin-right:.3em}"];
export { styles as styles };
